"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UuidUtils = void 0;
const fox_node_logger_1 = require("@vamstar/fox-node-logger");
const uuid_1 = require("uuid");
const VERSION_4 = 4;
class UuidUtils {
    static isUuid4(uuid) {
        try {
            return (0, uuid_1.validate)(uuid) && (0, uuid_1.version)(uuid) === VERSION_4;
        }
        catch (error) {
            fox_node_logger_1.log.error(`Error while checking the versions of uuid ... ${error}`);
        }
        return false;
    }
}
exports.UuidUtils = UuidUtils;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXVpZC11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy91dWlkLXV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILDhEQUErQztBQUMvQywrQkFBeUM7QUFFekMsTUFBTSxTQUFTLEdBQUcsQ0FBQyxDQUFDO0FBRXBCLE1BQWEsU0FBUztJQUNiLE1BQU0sQ0FBQyxPQUFPLENBQUMsSUFBWTtRQUNoQyxJQUFJO1lBQ0YsT0FBTyxJQUFBLGVBQVEsRUFBQyxJQUFJLENBQUMsSUFBSSxJQUFBLGNBQU8sRUFBQyxJQUFJLENBQUMsS0FBSyxTQUFTLENBQUM7U0FDdEQ7UUFBQyxPQUFPLEtBQUssRUFBRTtZQUNkLHFCQUFHLENBQUMsS0FBSyxDQUFDLGlEQUFpRCxLQUFLLEVBQUUsQ0FBQyxDQUFDO1NBQ3JFO1FBQ0QsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0NBQ0Y7QUFURCw4QkFTQyJ9